import { removeWhiteSpace } from 'utils/utils';


const numberType = {
    'fmc': 'M',
    'celular': 'C',
}


export const clientAdditionalInformation = ({ pha_data, additionalContacts }) => {
    return {
        "activateService": {
            "createBasketAndAddItemsMutation": {
                "basketCreateMutation": {
                    "included": {
                        "newInstance": {
                            "attributes": {
                                "leadStep": "customer_second_phone_number",
                                "salesContext": {
                                    "salespersonCode": `${pha_data?.user}`
                                }
                            }
                        }
                    }
                }
            },
            "createCustomerMutation": {
                "individualsCreateMutation": {
                    "included": {
                        "newInstance": {
                            "included": {
                                "contactMedia": [
                                    {
                                        "atrributes": {
                                            "useSameMsisdnFCM": additionalContacts.find((number) => number.useSameMsisdnFCM) ? true : false,
                                            "medium": {
                                                "telephoneNumber": additionalContacts?.filter(n => !n.useSameMsisdnFCM).map((number) => {
                                                    return {
                                                        "number": removeWhiteSpace(number.value),
                                                        "numberType": numberType[number.type?.toLowerCase()]
                                                    }
                                                })
                                            },
                                            "observacion": "Orden Home Activator"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        }
    }
}